<!--
// dxGetInputResolution
// dxGetOutputResolution
// dxSetOutputResolution

// dxGetOutputResolutionOptions
// dxGetSplitOptions
// dxGetSplitArea
// dxSetSplitArea

// dxGetProfiles
// dxSetDeviceByProfileKey
// dxSetProfiles
// dxSetProfileByKey
// dxSetSplitByOption-->

<template lang="jade">
  include ./mixin.jade
  +simpleGetButton('dxGetInputResolution')
  .row
    .col-xs-12
      fieldset
        legend dxSetInputResolution(VIRTUAL DEVICE ONLY, only for test 4K)
        span Set 4K
        input(type="checkbox" v-model="chose4k")
        +simpleReadOnlyInput('resolution4K')
        +simpleReadOnlyInput('resolutionNormal')
        button(@click="dxSetInputResolution") dxSetInputResolution
  +simpleGetButton('dxGetOutputResolutionOptions')
  +simpleGetButton('dxGetOutputResolution')
  .row
    .col-xs-12
      fieldset
        legend dxSetOutputResolution
        +simpleInput('outputRes.port')
        +simpleInput('outputRes.option')
        button(@click="dxSetOutputResolution") dxSetOutputResolution
  +simpleGetButton('dxGetOutputSplitOptions')
  +simpleGetButton('dxGetSplitArea')
  .row
    .col-xs-12
      fieldset
        legend dxSetSplitArea
        div
          label Port
          input.thin(number v-model='splitAreaPort')
        div(v-for="(id, sval) in splitArea" track-by="$index")
          span port : {{ id }}
          input.thin(number v-model="v" v-for="v in sval" track-by="$index" )
        button(@click="dxSetSplitArea") dxSetSplitArea
  +simpleGetButton('dxGetProfiles')
  .row
    .col-xs-12
      fieldset
        legend dxSetProfileByKey
        +simpleInput('profileIndex')
        button(@click="dxSetProfileByKey") dxSetProfileByKey
  .row
    .col-xs-12
      fieldset
        legend dxSetDeviceByProfileKey
        +simpleInput('profileIndexUWantToSet')
        button(@click="dxSetDeviceByProfileKey") dxSetDeviceByProfileKey
  .row
    .col-xs-12
      fieldset
        legend dxSetSplitByOption
        +simpleInput('splitOption')
        button(@click="dxSetSplitByOption") dxSetSplitByOption
  h2 (for VW-1404ZH-G only)
  +simpleGetButton('dxGetInputSource') 
  .row
    .col-xs-12
      fieldset
        legend dxSetInputSource 
        span isSourceFromHDMI &nbsp;
        input(type="checkbox" v-model="isSourceFromHDMI")
        br
        button(@click="dxSetInputSource") dxSetInputSource

</template>

<style scoped>
  .thin {
    width: 16%;
  }
</style>
<script>
  export default {
    data: () => ({
      splitOption: '1',
      resolution4K: '4096x2160@60Hz',
      resolutionNormal: '1920x1080@60Hz',
      chose4k: true,
      profileIndex: '1',
      profileName: 'testProfile',
      profileIndexUWantToSet: '1',
      profile: {
        pid: '1',
        content: {
          name: 'custom 1',
          split: {
            1: [0, 0, 960, 540, 0],
            2: [960, 0, 1920, 540, 0],
            3: [0, 540, 960, 1080, 0],
            4: [960, 540, 1920, 1080, 0]
          }
        }
      },
      outputRes: {
        port: '1',
        option: '3'
      },
      splitAreaPort: 1,
      splitArea: {
        1: [0, 0, 960, 540, 0],
        2: [960, 0, 1920, 540, 0],
        3: [0, 540, 960, 1080, 0],
        4: [960, 540, 1920, 1080, 0]
      },
      inResolution: '',
      isSourceFromHDMI: true
    }),
    methods: {
      sendAPI (cmd, params) {
        this.$dispatch('sendAPI', cmd, params)
      },
      dxSetInputSource () {
        this.sendAPI('dxSetInputSource', {
          isSourceFromHDMI: this.isSourceFromHDMI
        })
      },
      dxSetOutputResolution () {
        this.sendAPI('dxSetOutputResolution', {
          resolution: {
            [this.outputRes.port]: parseInt(this.outputRes.option)
          }
        })
      },
      dxSetSplitArea () {
        this.sendAPI('dxSetSplitArea', {
          split: {
            [this.splitAreaPort]: this.splitArea[this.splitAreaPort]
          }
        })
      },
      dxSetProfileByKey () {
        this.sendAPI('dxSetProfileByKey', {
          profiles: this.profileIndex
        })
      },
      dxSetDeviceByProfileKey () {
        this.sendAPI('dxSetDeviceByProfileKey', {
          profile: this.profileIndexUWantToSet
        })
      },
      dxSetInputResolution () {
        let resolution = this.chose4k ? this.resolution4K : this.resolutionNormal
        this.sendAPI('dxSetInputResolution', { resolution })
      },
      dxSetSplitByOption () {
        this.sendAPI('dxSetSplitByOption', {
          option: this.splitOption
        })
      }
    }
  }
</script>



// WEBPACK FOOTER //
// splitter.vue?55b61cf7